<section class="inicio">
  <div class="hero">
    <neo-slider *ngIf="secciones['inicio_hero'] && secciones['inicio_hero']['slider-hero']['slides'].length" class="slider"
      [id]="'slider-hero'" [slides]="secciones['inicio_hero']['slider-hero']['slides']" [paginacion]="true"
      [tipoPaginacion]="_TipoPaginadorSliderEnum.fraction" [handlers]="false" [loop]="false">
    </neo-slider>
  </div>

  <div class="zona-fan">
    <div class="container">
      <p class="section-tit1 isotipo-triple">
        <neo-span-inner-html [contenido]="zona_fan_tit"></neo-span-inner-html>
      </p>
      <article>
        <div class="blq-img">
          <picture>
            <img [src]="zona_fan_img['ruta']" [alt]="zona_fan_img['alt']" />
          </picture>
        </div>
        <div class="blq-cont">
          <div>
            <h2 class="section-tit2 isotipo-stroke">{{zona_fan_sub}}</h2>
            <neo-span-inner-html [contenido]="zona_fan_txt"></neo-span-inner-html>
            <a class="btn btn-secondary" [routerLink]="pathZonaFan" title="">
              Descubre más
            </a>
          </div>
        </div>
      </article>
    </div>
  </div>

  <neo-mapa-areas></neo-mapa-areas>
  
  <div class="espacios galeria">
    <div class="block-cont container">
      <h2 class="section-tit2 isotipo-stroke" *ngIf="espacios['titulo']" [innerHtml]="espacios['titulo']"></h2>
      <neo-slider #espaciosCarousel *ngIf="espacios['imagenes']" class="carousel" #carouselEspacios
        [slides]="espacios['imagenes']" [id]="'galeria-slider'" [handlers]="false" [slidesPerView]="'auto'"
        [spaceBetween]="20" [loop]="true" [mostrarGaleria]="true"></neo-slider>
    </div>
  </div>
      
      
      <!-- <div class="espacios galeria">
          <div class="block-cont container"> -->
      <!-- <?=lang('inicio_espacios')?> -->
      <!-- <h2 class="section-tit2 isotipo-stroke">
        <neo-span-inner-html [contenido]="espacios_tit"></neo-span-inner-html>
      </h2>
      <neo-slider class="carousel" [id]="'galeria-slider'" [slides]='imagesCarousel' [handlers]="false" [slidesPerView]="'auto'"
        [spaceBetween]="20" [loop]="true" [mostrarGaleria]="true"></neo-slider>
    </div>
  </div> -->

  <div class="servicios">
    <div class="container">
      <h2 class="section-tit1 isotipo-triple">
        <neo-span-inner-html [contenido]="celebraciones_tit"></neo-span-inner-html>
      </h2>
      <article class="cumpleanos">
        <div class="blq-img">
          <picture>
            <img [src]="celebraciones_img1['ruta']" [alt]="celebraciones_img1['alt']"/>
          </picture>
        </div>
        <div class="blq-cont">
          <div>
            <h3 class="section-tit2 isotipo-stroke">{{celebraciones_sub1}}</h3>
            <div class="blq-txt">
              <neo-span-inner-html [contenido]="celebraciones_txt1"></neo-span-inner-html>
            </div>
            <div class="blq-btn">
              <a class="btn btn-secondary" [routerLink]="pathCumpleanos" title="">
                Descubre más
              </a>
              <a class="btn btn-primary" (click)="accederReservar()" title="">
                Reserva ahora
              </a>
            </div>
          </div>
        </div>
      </article>
      <article class="comuniones">
        <div class="blq-img">
          <picture>
            <img [src]="celebraciones_img2['ruta']" [alt]="celebraciones_img2['alt']"/>
          </picture>
        </div>
        <div class="blq-cont">
          <div>
            <h3 class="section-tit2 isotipo-stroke">{{celebraciones_sub2}}</h3>
            <div class="blq-txt">
              <neo-span-inner-html [contenido]="celebraciones_txt2"></neo-span-inner-html>
            </div>
            <div class="blq-btn">
              <a class="btn btn-secondary" [routerLink]="pathComuniones" title="">
                Descubre más
              </a>
              <a class="btn btn-primary" (click)="accederReservar()" title="">
                Reserva ahora
              </a>
            </div>
          </div>
        </div>
      </article>
      <article class="otros">
        <div class="blq-img">
          <picture>
            <img [src]="celebraciones_img3['ruta']" [alt]="celebraciones_img3['alt']"/>
          </picture>
        </div>
        <div class="blq-cont">
          <div>
            <h3 class="section-tit2 isotipo-stroke">{{celebraciones_sub3}}</h3>
            <div class="blq-txt">
              <neo-span-inner-html [contenido]="celebraciones_txt3"></neo-span-inner-html>
            </div>
            <div class="blq-btn">
              <a class="btn btn-secondary" [routerLink]="pathOtrosEventos" title="">
                Descubre más
              </a>
              <a class="btn btn-primary" (click)="accederReservar()" title="">
                Reserva ahora
              </a>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</section>

<neo-bottom-cta></neo-bottom-cta>



<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
  [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>
<!-- Test Traducciones -->
<!-- <h2>{{'AUTH.EMAIL' | transloco}}</h2> -->
<!--Demo DuaLazy-->
<!-- <div class="flex-center" style="width: 100%">
  <div class="duaLazy duaLazyTB">
    <img src="assets/images/icons/logo.svg" alt="'NOMBRE COMERCIAL'" />
  </div>
</div>
<div class="flex-center" style="width: 100%">
  <div class="duaLazy duaLazyLR">
    <img src="assets/images/icons/logo.svg" alt="'NOMBRE COMERCIAL'" />
  </div>
  <div class="duaLazy duaLazyRL">
    <img src="assets/images/icons/logo.svg" alt="'NOMBRE COMERCIAL'" />
  </div>
</div>
<div class="flex-center" style="width: 100%">
  <div class="duaLazy duaLazyBT">
    <img src="assets/images/icons/logo.svg" alt="'NOMBRE COMERCIAL'" />
  </div>
</div> -->

<!-- demo -->
<!-- <section class="section-carousel">
  <div class="galeria">
    <div class="block-cont container">
      <neo-slider class="carousel" [id]="'galeria-slider'" [images] = 'imagesCarousel' [handlers]="false" [slidesPerView]="3" [spaceBetween]="20" [loop]="true" [mostrarGaleria]="true"></neo-slider>
    </div>
  </div>
</section> -->
